import { ToggleGroup } from '@shared/ui/toggle-group';

import type { FundOption } from '../model/fund';

export interface FundPickerProps {
  title?: string;
  funds: readonly FundOption[];
  /** 고른 펀드 idx 목록 */
  value: readonly number[];
  onChange: (value: number[]) => void;
}

/**
 * 펀드를 여러 개 고르는 토글 버튼 묶음 + 전체 선택 / 전체 해제(ToggleGroup atom, 결정 B9).
 * 머리말 높이 60 · 아래 선 · 오른쪽 여백 20, 목록 여백 좌우 32 · 위아래 20 은 Figma 값.
 * 목록 위 20 = atom 의 머리말–목록 간격 16(gap-4, 바꿀 수 없다) + pt-1(4).
 * 긴 펀드 이름은 한 줄 말줄임(전체 이름은 title) — 버튼 크기가 일정하다(메일 발송하기와 같다, 2026-10-07 사용자 DD-70).
 * (예전엔 두 줄로 접어 버튼 위아래 여백이 없어 보였다)
 */
export function FundPicker({ title, funds, value, onChange }: FundPickerProps) {
  return (
    <ToggleGroup<number>
      title={title}
      items={funds.map((fund) => ({
        value: fund.idx,
        label: fund.name,
      }))}
      value={[...value]}
      onChange={onChange}
      selection="multiple"
      selectAll
      size="sm"
      itemWidth="xl"
      className="w-full bg-bg-surface p-5"
      headerClassName="h-(--size-row) border-b border-border-subtle pr-5"
      gap="lg"
      listClassName="items-start px-8 pb-5"
    />
  );
}
